var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "site-navigation navigation-groups",
      class: {
        "site-navigation-empty":
          typeof _vm.navigationGroups === "undefined" ||
          _vm.navigationGroups === null ||
          _vm.navigationGroups.length === 0
      }
    },
    _vm._l(_vm.navigationGroups, function(navGroup) {
      return !(_vm.mobileBigAndBelow && navGroup.cssclass === "popular-desktop")
        ? _c("li", { class: ["navigation-group", navGroup.layout] }, [
            navGroup.text
              ? _c(
                  "h3",
                  [
                    navGroup.cssclass && navGroup.cssclass != "default"
                      ? _c("v-icon", { class: navGroup.cssclass }, [
                          _vm._v(_vm._s(navGroup.cssclass))
                        ])
                      : _vm._e(),
                    _vm._v("\n        " + _vm._s(navGroup.text) + "\n      ")
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "navigation" },
              _vm._l(navGroup.fwnavigationitems, function(item, index) {
                return item.display === "ALWAYS" ||
                  (item.display === "LOGGEDIN" && _vm.isLoggedIn) ||
                  (item.display === "LOGGEDOUT" && !_vm.isLoggedIn)
                  ? _c(
                      "li",
                      {
                        key: index,
                        staticClass: "navigation-item",
                        class: {
                          navigationDisabled:
                            _vm.isNavigationDisabledDueBetPlacement &&
                            _vm.isLinkOutOfSportsArea(item),
                          "item-disabled":
                            !_vm.isDocumentsUploadRequired &&
                            item.routing === "/account/uploadcenter"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handler(item)
                          }
                        }
                      },
                      [
                        item.area === "taxStatement"
                          ? _c("a", {
                              staticStyle: { display: "none" },
                              attrs: {
                                download: "Tax Statement.pdf",
                                id: "generatePDF",
                                href: _vm.userPdf
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.linktype === "JAVASCRIPT"
                          ? _c("span", [_vm._v(_vm._s(item.text))])
                          : item.linktype === "INTERNAL"
                          ? _c(
                              "router-link",
                              {
                                class:
                                  item.cssclass === "icon-live"
                                    ? "icon-live"
                                    : "",
                                attrs: {
                                  to: {
                                    path:
                                      "/" + _vm.$i18n.locale + item.area || "/"
                                  },
                                  id: item.area
                                }
                              },
                              [
                                item.cssclass && item.cssclass != "default"
                                  ? _c("icon", {
                                      attrs: {
                                        name: item.cssclass,
                                        isFromSiteNavigation: true,
                                        count:
                                          item.cssclass === "icon-live"
                                            ? _vm.liveEventsNumber
                                            : 0
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(item.text))])
                              ],
                              1
                            )
                          : item.linktype === "URL"
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    path:
                                      "/" + _vm.$i18n.locale + item.routing ||
                                      "/"
                                  },
                                  id: item.routing
                                }
                              },
                              [
                                item.cssclass && item.cssclass != "default"
                                  ? _c("icon", {
                                      attrs: { name: item.cssclass }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(item.text))])
                              ],
                              1
                            )
                          : item.linktype === "BONAVIGATION"
                          ? _c(
                              "router-link",
                              { attrs: { to: _vm.getBoNavigationPath(item) } },
                              [
                                item.cssclass && item.cssclass != "default"
                                  ? _c("icon", {
                                      attrs: { name: item.cssclass }
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.text) +
                                    "\n          "
                                )
                              ],
                              1
                            )
                          : _c(
                              "a",
                              {
                                class: item.cssclass,
                                attrs: {
                                  href: item.location,
                                  setTarget: _vm.setTarget(
                                    item.idfwnavigationitem,
                                    item.target
                                  ),
                                  id: item.idfwnavigationitem,
                                  rel: item.rel,
                                  "aria-label": item.rel
                                }
                              },
                              [
                                item.cssclass && item.cssclass != "default"
                                  ? _c("icon", {
                                      attrs: { name: item.cssclass }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "item-text" }, [
                                  _vm._v(_vm._s(item.text))
                                ])
                              ],
                              1
                            )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            )
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e2da3c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2da3c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SiteNavigation.vue
// module id = null
// module chunks = 